module.exports = __webpack_public_path__ + "static/media/pl.b56a3f06.svg";